export default __webpack_public_path__ + "static/media/Nove_Mlyny.2f54364f.jpg";